import { render } from "./whr-home-link.vue?vue&type=template&id=0c67ff04&scoped=true"
import script from "./whr-home-link.vue?vue&type=script&lang=js"
export * from "./whr-home-link.vue?vue&type=script&lang=js"

import "./whr-home-link.vue?vue&type=style&index=0&id=0c67ff04&lang=scss&scoped=true"
import "./whr-home-link.vue?vue&type=style&index=1&id=0c67ff04&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c67ff04"]])

export default __exports__